import React from 'react';
import SkeletonBox from './SkeletonBox';
import './FlightSearchSkeleton.css';

const FlightSearchSkeleton = () => (
  <div className="flightSearchSkeleton">
    <div className="flightSearchSkeleton__content">
      <SkeletonBox width="420px" height="40px" className="flightSearchSkeleton__heading" />

      <div className="flightSearchSkeleton__mainTab">
        <SkeletonBox width="90px" height="60px" radius="0" className="flightSearchSkeleton__onDark" />
        <SkeletonBox width="90px" height="60px" radius="0" className="flightSearchSkeleton__onDark" />
        <SkeletonBox width="90px" height="60px" radius="0" className="flightSearchSkeleton__onDark" />
        <SkeletonBox width="90px" height="60px" radius="0" className="flightSearchSkeleton__onDark" />
      </div>

      <div className="flightSearchSkeleton__card">
        <div className="flightSearchSkeleton__tabs">
          <SkeletonBox width="90px" height="36px" radius="42px" />
          <SkeletonBox width="110px" height="36px" radius="42px" />
          <SkeletonBox width="110px" height="36px" radius="42px" />
        </div>

        <div className="flightSearchSkeleton__fields">
          <SkeletonBox width="100%" height="54px" radius="10px" />
          <SkeletonBox width="100%" height="54px" radius="10px" />
          <SkeletonBox width="100%" height="54px" radius="10px" />
          <SkeletonBox width="100%" height="54px" radius="10px" />
          <SkeletonBox width="100%" height="54px" radius="10px" />
        </div>

        <div className="flightSearchSkeleton__footer">
          <div className="flightSearchSkeleton__pills">
            <SkeletonBox width="130px" height="44px" radius="15px" />
            <SkeletonBox width="130px" height="44px" radius="15px" />
            <SkeletonBox width="130px" height="44px" radius="15px" />
          </div>
          <SkeletonBox width="160px" height="46px" radius="42px" />
        </div>
      </div>
    </div>
  </div>
);

export default FlightSearchSkeleton;
